export default {
  dashboard: {
    cgvText: 'Please read the general terms and conditions of sale below and confirm them to continue browsing your Customer Area.',
    accept: 'Accept',
    refuse: 'Decline',
    linkedInConnectNOK: 'Automated posting to LinkedIn.<br>\n' +
            'You can now create, edit and delete publications, comments and reactions from your professional account. To restart your broadcast, please click on the button below.\n<br><br>' +
            'Before clicking on the button, please make sure you are the administrator of the LinkedIn company page powered by Ubiflow, and that you are logged in.',
    maintenance: 'Dear customer,<br /><br />\n' +
        'We would like to inform you that exceptionally, our customer service will be closed on Thursday, May 30. Indeed, we are organizing a company seminar in order to improve our services and our support.<br />\n' +
        'We will set up a minimum service in order to monitor the proper functioning of our platform and your tools.<br /><br />\n' +
        'We will be back the next day, Friday May 31, ready to meet all your needs.<br /><br />\n' +
        'We thank you for your understanding and loyalty.<br /><br />\n' +
        'Sincerely,\n<br />The Ubiflow team.\n',
    dialogTitle: 'Welcome to your new Customer Space',
    dialogWelcome: 'Hello,<br><br>' +
            "You have been automatically redirected to your new Ubiflow's Customer Space.<br><br>" +
            'What has changed ?<br>' +
            '- better <strong>responsiveness</strong> for an ever faster diffusion,<br>' +
            '- <strong>enriched data</strong> to better manage your business,<br>' +
            '- a <strong>new interface</strong> for a simplified navigation,<br>' +
            '- it is now possible to access it from your <strong>mobile phone</strong>.',
    dialogTextBottom: 'You can still access your old customer space during some months. ' +
            'To achieve this, click on "Go back to old Customer Space" in the upper right of your screen.',
    dialogClose: 'Close',
    myAds: 'My ads',
    activeAds: 'active ads in your portfolio',
    myAds_link: 'Go to my ads',
    myDiffusions: 'My diffusions',
    reportDate: 'Report at',
    diffusionPercentageText: 'of correctly diffused ads',
    myIntegrations: 'My integrations',
    integrations: 'Integrations',
    fullReportLink: 'See full report',
    myLastAds: 'My last ads',
    myLastAdsLink: 'See all ads',
    cmDiscoverTitle: 'Contact Manager, tool to centralize and manage your contacts',
    cmDiscoverText: 'Centralize and manage all your leads (calls and emails) in real time on a single interface.',
    cmDiscoverButton: 'Discover the product Contact Manager',
    cmYouReceived: 'You received',
    cmContactsWithCount: '{{count}} contact',
    cmContactsWithCount_plural: '{{count}} contacts',
    cmFor: 'for',
    cmAdsWithCount: '{{count}} ad',
    cmAdsWithCount_plural: '{{count}} ads',
    cmLast7Days: 'over the last 7 days.',
    cmPortals: 'Portals',
    cmAds: 'Ads',
    cmColumnTitle: 'Title',
    cmColumnContacts: 'Contacts',
    metaTitle: 'Dashboard',
    beContacted: 'Interested by this product? Be contacted by a comercial advisor.',
    decouvrir: 'Discover the product',
    beCall: 'Be contacted by an advisor',
    titleProduitNonActive: 'THIS FEATURE IS NOT ACTIVATED IN YOUR SUBSCRIPTION.',
    txtProduitNonActiveDiffusion: 'Benefit from all the advantages of difusing your ads with Ubiflow. We send your ads to all regional, national and specialized portals, also to your website. Manage and schedule the selection of your ads, customize the contact information and monitor your diffusions with our diffusion and presence reports.',
    txtProduitNonActiveCM: 'Centralize and manage all your leads (calls and emails) in real time on a single interface.',
    txtProduitNonActiveSocialManagment: 'Discover the Social Manager offer and develop a real Social Media strategy. Ubiflow offers you a turnkey, time-saving solution. Automatically publish your ads on your social networks (Facebook, Instagram, LinkedIn, Google Business Profile) and create your own editorial content with the help of artificial intelligence. Our integrated editorial calendar makes it easy to keep track of all your publications. What\'s more, other functionalities enhance this offer to boost your visibility and maximize your impact on social networks.Translated with DeepL.com (free version)',
    emailSend: 'Your request has been sent. Our team will contact you as soon as possible.',
    txtPopupSFC: '<p class="text-justify" style="color: black">From this new customer space, easily access your local referencing solution ' +
            '"Se Faire Connaître", <strong>by clicking on your left on the "Local Presence - Se Faire Connaître"</strong> ' +
            'section. </p><p class="text-justify" style="color: black">Also discover all our other products. </p><p class="text-justify"' +
            ' style="color: black">Remember to add to your favorites the login link to ' +
            'the new space: <a href="https://espace-client.ubiflow.net/login">https://espace-client.ubiflow.net/login</a>. of diffusion and Lead management adapted to your ' +
            'activity. Do not hesitate to contact us for a <strong>free demonstration.</strong></p>',
    txtChekboxPopupSFC: 'I understood. Do not display this message again for my future connections.',
    txtTitrePopupSFC: "Welcome to your new Ubiflow's Customer Space !",
    activePrograms: 'active programs in your portfolio',
    myPrograms: 'My programs',
    myPrograms_link: 'Access my programs',
    contactsEvolution: 'Evolution of contact number',
    vsLastMonth: 'vs previous month',
    vsLastDay: 'vs previous day',
    vsLastWeek: 'vs previous week',
    vsLastQuarter: 'vs previous quarter',
    quarter: 'Q',
    kpi: 'Period indicators',
    contactsUnit: 'contacts',
    requestDemo: 'Request a demo',
    noData: 'No data',
    recentInstallationText: 'As the solution was recently installed, this data and curve are fictitious. Your flow delay will be calculated after 3 months.',
    moreInfoContactsEvolution: 'Learn more about the evolution of your contacts',
    dateRangeMonthly: 'from {{from}} to {{to}}',
    dateRangeDaily: 'from {{from}} to {{to}}',
    socialEvolutionTitle: 'Evolution of interaction volume',
    socialInteractionsUnit: 'interactions',
    moreInfoSocialEvolution: 'Learn more about your social network statistics',
    delaiEcoulementTitle: 'Ad turnover time',
    delaiEcoulementUnit: 'days',
    delaiEcoulementNoData: 'No ads sold in the last 7 days — turnover time unavailable.',
    delaiEcoulementAverage7DaysLabel: 'Average over the last 7 days',
    delaiEcoulementUnitAverage7Days: 'days (7-day average)',
    delaiEcoulementEvolution: 'Turnover time evolution',
    txtProduitNonActiveDelaiEcoulement: 'Track the average turnover time of your ads and compare your performance over time. Optimize your distribution strategy with key indicators adapted to your seniority.',
    adLifetimeDetailLink: 'Turnover time detail',
    adLifetimeDetailReference: 'Reference',
    adLifetimeDetailCreationDate: 'Creation date',
    adLifetimeDetailDeletionDate: 'Deletion date',
    adLifetimeDetailLifetimeDays: 'Turnover time (days)',
    adLifetimeDetailEmpty: 'No deleted ads',
    adLifetimeDetailExportFilename: 'deleted_ads',
    adLifetimeDetailExportButton: 'Export'
  }
}
